<template>
    <resource-booking-category v-if="oneCategory" :categoryId="oneCategory.id" :globalSiteSetting="globalSiteSetting" />
    <div v-else>
        <div v-if="showHeader && filteredCategories.length > 0" class="title primary--text text-center my-4">{{title}}</div>
        <resource-booking-category-list
            :link="categoryPage"
            :globalSiteSetting="globalSiteSetting"
            :onlyShowCategories="categoriesToDisplay"
            :maxPerRow="maxPerRow"
        />
    </div>
</template>

<script>
import ResourceBookingCategory from './ResourceBookingCategory.vue'
import ResourceBookingCategoryList from './ResourceBookingCategoryList.vue'
export default {
    name: 'zoezi-resource-booking-start-page',

    zoezi: {
        title: 'Resource booking start page',
        icon: 'mdi-format-list-text',
        addon: 'ResourceBooking'
    },

    components: {
        ResourceBookingCategory,
        ResourceBookingCategoryList
    },

    props: {
        showHeader: {
            title: 'Show header',
            type: Boolean,
            default: true
        },
        title: {
            title: 'Title',
            type: String,
            default: () => window.$translate('Book appointment'),
            visible: 'showHeader'
        },
        categoryPage: {
            title: 'Page with category',
            type: String,
            fulltype: 'page'
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        categoriesToDisplay: {
            title: 'Categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getResourceBookingCategories(),
                placeholder: 'List all categories'
            },
            default: () => []
        },
        maxPerRow: {
            title: 'Max number of cards per row',
            type: Number,
            fulltype: 'number-slider',
            typeinfo: {
                min: 1,
                max: 4,
                step: 1
            },
            default: 4,
            global: true
        }
    },

    data: () => ({
    }),

    computed: {
        categories() {
            return this.$store.state.settings?.resourcebookingcategories || [];
        },
        filterOnSites() {
            if (this.globalSiteSetting && this.$store.state.selectedSiteId) {
                return this.$store.state.selectedSiteId;
            }
            return null;
        },
        filteredCategories() {
            let result = this.categories;
            if (this.filterOnSites) {
                result = result.filter(c => c.sites && c.sites.includes(this.filterOnSites));
            }
            if (this.categoriesToDisplay?.length) {
                result = result.filter(c => this.categoriesToDisplay.includes(c.id));
            }

            return result;
        },
        oneCategory() {
            return this.filteredCategories.length === 1 ? this.filteredCategories[0] : null;
        }
    }
}
</script>
